import { ReactElement } from "react";
import { Popover, Tooltip } from "antd";
import type { TooltipPlacement } from "antd/es/tooltip";
import LinkPopover from "../LinkPopover";
import styles from "./index.module.scss";

const TOOLTIP_STYLE = {
  minHeight: "auto",
  padding: 10,
  borderRadius: 8,
  background: "#242424",
};

export interface ILinkDialog {
  type?: "popover" | "tooltip";
  children: ReactElement;
  placement?: TooltipPlacement;
  popoverProps?: {
    sourceIcon?: string;
    source?: string;
    title?: string;
    url?: string;
    desc?: string;
    className?: string;
    titleCls?: string;
    descCls?: string;
    topCls?: string;
    showArrow?: boolean;
    onDelete?: () => void;
    onClick?: () => void;
  };
  tooltipProps?: {
    content: string;
  };
}

const LinkDialog: React.FC<ILinkDialog> = ({
  children,
  type = "popover",
  placement = "top",
  popoverProps,
  tooltipProps,
}) => {
  if (type === "tooltip") {
    const titleContent = (
      <div className={styles.tooltipContainer}>{tooltipProps?.content}</div>
    );
    return (
      <Tooltip
        title={titleContent}
        placement={placement}
        overlayStyle={{ maxWidth: "max-content" }}
        overlayInnerStyle={TOOLTIP_STYLE}
        overlayClassName={styles.tooltipOverlay}
      >
        {children}
      </Tooltip>
    );
  }

  return (
    <Popover
      title={false}
      arrow={false}
      placement={placement}
      content={<LinkPopover {...popoverProps} />}
      overlayInnerStyle={{
        padding: 0,
      }}
    >
      {children}
    </Popover>
  );
};
export default LinkDialog;
